export default __webpack_public_path__ + "static/media/Circle-Words-Wordmark.173471d4.png";